import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Flex, Form, Input, Modal, Typography } from 'antd';
import theme from '@/utils/themes/Themes.module.scss';
import mcc from '@/components/MainContainer/MainContainerComponents.module.scss';
import { IModalProps } from 'tkmp-lib/src/interfaces';
const { TextArea } = Input;
import { useStores } from '@/utils/hooks/useStores';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

type TAgreeCheckbox = {
    isPersonal: boolean;
    isViewed: boolean;
};

const ModalQuestionForm = ({ callback_open, callback_close }: IModalProps) => {
    const [form] = Form.useForm();
    const LOCALIZATION = useLocalization();
    const {
        userStore: { USERNAME },
    } = useStores();

    const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

    useEffect(() => {
        setIsAuthorized(USERNAME !== '');
    }, [USERNAME]);

    const callback_submit = (values: any) => {
        console.log('SUBMIT ! => ', values);
    };

    const [isAgree, setIsAgree] = useState<TAgreeCheckbox>({ isPersonal: false, isViewed: false });

    return (
        <Modal
            className={`${theme.GeneralContainer__Theme} ${mcc.modal}`}
            centered
            open={callback_open}
            onCancel={callback_close}
            width={1064}
            okButtonProps={{
                style: { display: 'none' },
            }}
            cancelButtonProps={{
                style: { display: 'none' },
            }}
        >
            <Form
                layout={'vertical'}
                className={mcc.question_container}
                form={form}
                onFinish={(values) => callback_submit(values)}
            >
                <Typography.Text
                    className={`text-32-500`}
                    style={{ textAlign: 'center' }}
                >
                    {LOCALIZATION.questionForm.title}
                </Typography.Text>
                <Flex
                    vertical
                    className={mcc.text_block}
                >
                    <Typography.Text className={`text-16-400`}>
                        {LOCALIZATION.questionForm.description.mainText}{' '}
                    </Typography.Text>
                    <ul>
                        {LOCALIZATION.questionForm.description.points.map((item: string) => (
                            <li>
                                <Typography.Text className={`text-16-400`}>{item}</Typography.Text>
                            </li>
                        ))}
                    </ul>
                </Flex>
                <Flex vertical>
                    {!isAuthorized && (
                        <>
                            <Flex className={mcc.form_block}>
                                <Form.Item
                                    label={LOCALIZATION.questionForm.form.labels.fio}
                                    name={'fio'}
                                    className={mcc.form_item}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label={LOCALIZATION.questionForm.form.labels.email}
                                    name={'email'}
                                    className={mcc.form_item}
                                >
                                    <Input />
                                </Form.Item>
                            </Flex>
                            <Flex className={mcc.form_block}>
                                <Form.Item
                                    label={LOCALIZATION.questionForm.form.labels.phone}
                                    name={'phone'}
                                >
                                    <Input />
                                </Form.Item>
                            </Flex>
                        </>
                    )}
                    <Form.Item
                        label={LOCALIZATION.questionForm.form.labels.description}
                        name={'description'}
                        className={mcc.form_item}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={LOCALIZATION.questionForm.form.labels.document}
                        name={'document'}
                        className={mcc.form_item}
                    ></Form.Item>
                </Flex>
                <Flex vertical>
                    <Checkbox
                        checked={isAgree.isPersonal}
                        onChange={(e) => setIsAgree({ ...isAgree, isPersonal: e.target.checked })}
                    >
                        {LOCALIZATION.questionForm.checkboxes.personalData}
                    </Checkbox>
                    <Checkbox
                        checked={isAgree.isViewed}
                        onChange={(e) => setIsAgree({ ...isAgree, isViewed: e.target.checked })}
                    >
                        {LOCALIZATION.questionForm.checkboxes.termsViewed}
                    </Checkbox>
                </Flex>
                <Flex className={mcc.form_block}>
                    <Button
                        disabled={Object.values(isAgree).some((s) => !s)}
                        size={'large'}
                        style={{ width: '316px' }}
                        htmlType={'submit'}
                    >
                        {LOCALIZATION.questionForm.submitButton}
                    </Button>
                </Flex>
            </Form>
        </Modal>
    );
};

export default ModalQuestionForm;
